import type { FunctionComponent } from "react";

import { BaseLink } from "shared/components/common/base-link";

import type { entityLinkNameSize } from "scmp-app/components/header/features/entity-link";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import { Container } from "scmp-app/components/header/features/section-entity-link/styles";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { pathname as videoHomepagePathname } from "scmp-app/pages/video";

export type HeaderFeaturesVideoEntityLinkProps = HeaderFeatureCommonProps & {
  size?: entityLinkNameSize;
};

export const HeaderFeaturesVideoEntityLink: FunctionComponent<
  HeaderFeaturesVideoEntityLinkProps
> = ({ size = "small", ...props }) => (
  <Container $size={size} {...getResponsiveProps(props)}>
    <BaseLink pathname={videoHomepagePathname}>Video</BaseLink>
  </Container>
);

HeaderFeaturesVideoEntityLink.displayName = "HeaderFeaturesVideoEntityLink";
